import { render, staticRenderFns } from "./grid-based-search-results.vue?vue&type=template&id=223193ee&scoped=true&"
import script from "./grid-based-search-results.vue?vue&type=script&lang=js&"
export * from "./grid-based-search-results.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=223193ee&scoped=true&lang=css&"
import style1 from "./grid-based-search-results.vue?vue&type=style&index=1&id=223193ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223193ee",
  null
  
)

export default component.exports